import(/* webpackMode: "eager" */ "/vercel/path0/src/app/case-study/[slug]/_components/architecture_and_scale/case_study_architecture.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/case-study/[slug]/_components/challenge/case_study_challenge.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/case-study/[slug]/_components/conclusion/CaseStudyConclusion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/case-study/[slug]/_components/controllers/BlurController.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/case-study/[slug]/_components/controllers/NavigationUpdater.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/case-study/[slug]/_components/gallery/CaseStudyGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/case-study/[slug]/_components/hero/CaseStudyHero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/case-study/[slug]/_components/infrastructure/case_study_infrastructure.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/case-study/[slug]/_components/overview/case_study_overview.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/case-study/[slug]/_components/related/case_study_related.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/case-study/[slug]/_components/results/case_study_results.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/case-study/[slug]/_components/social_share/CaseStudySocialShare.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/case-study/[slug]/_components/solution/case_study_solution.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/case-study/[slug]/_components/tech_stack/case_study_tech_stack.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/case-study/[slug]/_components/views/case_study_views.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/case-study/[slug]/_components/views/ViewTracker.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/case-study/[slug]/case_study.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/static/data/projects/antimanti-tile.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/scroll_indicator/ScrollIndicator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/study_case_card/CaseStudyCard.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/topline/topline.module.scss");
